import { Dispatch, FC, SetStateAction } from 'react';

import { AvatarListItem } from './AvatarListItem';
import { Replica } from 'entities/tavus/replica';
import { Loader } from 'shared/ui';

interface IProps {
  replicas: Replica[];
  replicasLoading: boolean;
  setSelectedReplica: (replica: Replica | null) => void;
  selectedReplica?: Replica | null;
}

export const AvatarList: FC<IProps> = ({
  replicas,
  replicasLoading,
  setSelectedReplica,
  selectedReplica
}) => {
  return replicasLoading ? (
    <div className="ag-flex ag-flex-col ag-items-center ag-h-full ag-justify-center">
      <Loader size={56} />
    </div>
  ) : (
    <div className="ag-grid ag-gap-4 ag-grid-cols-2 sm:ag-grid-cols-3">
      {replicas.map((replica) => (
        <div key={replica.replica_id}>
          <AvatarListItem
            replica={replica}
            onChooseReplica={(replica) => setSelectedReplica(replica)}
            isActive={selectedReplica?.replica_id === replica.replica_id}
          />
        </div>
      ))}
    </div>
  );
};
